export default "__VITE_ASSET__CUcF1Mhp__"